var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBoxHeaderArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 10,
    viewBox: "0 0 11 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 4.41533C10.3229 4.41533 10.5847 4.6771 10.5847 5C10.5847 5.3229 10.3229 5.58467 10 5.58467V4.41533ZM0.586577 5.41342C0.35825 5.1851 0.35825 4.8149 0.586577 4.58658L4.30738 0.865773C4.53571 0.637446 4.9059 0.637446 5.13423 0.865773C5.36255 1.0941 5.36255 1.46429 5.13423 1.69262L1.82685 5L5.13423 8.30738C5.36255 8.53571 5.36255 8.9059 5.13423 9.13423C4.9059 9.36255 4.53571 9.36255 4.30738 9.13423L0.586577 5.41342ZM10 5.58467H1V4.41533H10V5.58467Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoxHeaderArrow);
export default __webpack_public_path__ + "static/media/box-header-arrow.d7603788.svg";
export { ForwardRef as ReactComponent };